module.exports = __webpack_public_path__ + "img/big.a45dd8ac.jpg";